<div class="f-loading-container-1">
  <app-skeleton class="header-block" />
  <div class="table-block">
    @for (i of [1, 2, 3, 4]; track i) {
      <div class="table-column">
        <app-skeleton />

        <div class="table-column-items">
          @for (j of [1, 2, 3, 4, 5, 6, 7]; track j) {
            <app-skeleton />
          }
        </div>
      </div>
    }
  </div>
  <div class="block-list">
    @for (i of [1, 2, 3, 4]; track i) {
      <app-skeleton class="block-list-item" />
    }
  </div>
</div>

<div class="f-loading-container-2">
  <div class="list">
    <app-skeleton class="list-header" />

    @for (i of [1, 2]; track i) {
      <app-skeleton class="list-item" />
    }
  </div>
  <app-skeleton class="right-block" />
</div>

<div class="f-loading-container-3">
  <app-skeleton class="left-item" />
  <app-skeleton class="right-item" />
</div>

<div class="f-loading-container-4">
  <app-skeleton class="block-item" />
</div>

<div class="f-loading-container-5">
  <app-skeleton class="mini-block" />
  <app-skeleton class="mini-block" />
</div>
